import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT } from './variants';

type Props = {
  children: React.ReactNode;
};

/**
 * Cross-fade + slight rise wrapper for route content. Used inside
 * <AnimatePresence mode="wait"> so one page fades out before the next
 * fades in. Renders children directly under reduced-motion.
 */
const PageTransition: React.FC<Props> = ({ children }) => {
  const prefersReducedMotion = useReducedMotion();

  if (prefersReducedMotion) {
    return <>{children}</>;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.35, ease: EASE_OUT }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
